<template>
  <div class="main-content">
    <!-- BradCrumb header Start-->
    <section class="inner-header-bg-con">
      <div class="container">
        <!-- Breadcrumb Start-->
        <div class="section-breadcrumb contact-breadcrumb">
          <div class="container">
            <div class="row">
              <div
                class="col-md-12 justify-content-center align-self-center pb-2"
              >
                <div class="breadcrumb-content">
                  <div class="title-section">
                    <h1 class="title text-center text-white">Contact Us</h1>
                  </div>
                  <div class="breadcrumb-nav">
                    <ul class="breadcrumb-link text-center list-unstyled mb-0">
                      <li class="text-white">
                        <i class="mdi mdi-home theme-light-color pr-2"></i>
                        <a href="index.html">Home</a>
                      </li>
                      <li class="theme-light-color active">Contact</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Breadcrumb End -->
      </div>
    </section>
    <!-- BradCrumb header End -->
    <!-- Start Contact Area -->
    <section class="section contact-area">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-6 col-12">
            <div class="contact-main form-box">
              <div class="contact-inner z-index9">
                <div class="section-title">
                  <h2 class="text-white">Connect with our Team</h2>
                </div>
                <div class="contact-address mt-5">
                  <h2 class="text-white">Visit our location</h2>
                  <div class="address mt-2">
                    <p class="text-white">
                      1333 Ashton Road, Suite 1800<br />
                      Hanover, MD 21076 <br />
                      <br />
                    </p>
                  </div>
                </div>
                <div
                  id="map-container-google-1"
                  class="z-depth-1-half map-container"
                  style="height: 280px"
                >
                  <iframe
                    src="https://maps.google.com/maps?q=1333 Ashton Road Hanover, MD 21076&t=&z=13&ie=UTF8&iwloc=&output=embed"
                    frameborder="0"
                    style="border:0"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-12">
            <form
              action=""
              @submit.prevent="sendEmail"
              class="wpcf7-form init"
              novalidate="novalidate"
              data-status="init"
            >
              <div class="mt-5">
                <div class="row">
                  <input
                    type="hidden"
                    name="to_email"
                    value="laial.beidoun@moveamerica.org"
                    size="40"
                  />
                  <input
                    type="hidden"
                    name="cc_email"
                    value="nilanb@umbc.edu"
                    size="40"
                  />
                  <div class="col-sm-6 col-12">
                    <div class="form-group">
                      <input
                        type="text"
                        class="form-control"
                        name="name"
                        v-model="name"
                        placeholder="Enter name"
                        required="required"
                      />
                    </div>
                  </div>
                  <div class="col-sm-6 col-12">
                    <div class="form-group">
                      <input
                        type="email"
                        class="form-control"
                        name="email"
                        v-model="email"
                        placeholder="Enter email"
                        required="required"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6 col-12">
                    <div class="form-group">
                      <input
                        type="text"
                        name="phone"
                        v-model="phone"
                        value=""
                        class="form-control"
                        placeholder="Your Phone"
                      />
                    </div>
                  </div>
                  <div class="col-sm-6 col-12">
                    <div class="form-group">
                      <input
                        type="text"
                        name="company"
                        v-model="company"
                        value=""
                        size="40"
                        class="form-control"
                        placeholder="Your Company"
                      />
                    </div>
                  </div>
                </div>
                <!-- <div class = "row">
								<div class="col-12">
									<div class="form-group">
										<p><strong> Reason for Contact (check all reasons for contacting us that apply)</strong></p>
										<div class="form-check">
											<input class="form-check-input" type="checkbox" value="operations" id="operations" v-model="checkedcontact">
											<label class="form-check-label" for="flexCheckDefault">
												 Institute Operations - for those with inquiries regarding running of the institute or joining the staff 
											</label>
										</div>
										<div class="form-check">
											<input class="form-check-input" type="checkbox" value="customers" id="customers" v-model="checkedcontact">
											<label class="form-check-label" for="flexCheckChecked">
												Potential Government Customers – for those interested in hiring the institute to help address their capability or technology challenges 
											</label>
										</div>
										<div class="form-check">
											<input class="form-check-input" type="checkbox" value="members" id="members" v-model="checkedcontact">
											<label class="form-check-label" for="flexCheckChecked">
												Potential Members - those with relevant expertise and interest in join the problem-solving membership team.
											</label>
										</div>
									</div>
								</div>
							</div> -->
                <div class="row">
                  <div class="col-12">
                    <div class="form-group">
                      <textarea
                        name="message"
                        v-model="message"
                        class="form-control"
                        rows="7"
                        cols="25"
                        placeholder="Message"
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <button
                      type="submit"
                      name="submit"
                      value="Send"
                      class="btn theme-btn w-100 rounded"
                    >
                      Send Message
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
    <!-- End Contact Area -->
  </div>
</template>
<script>
import emailjs from "emailjs-com";

export default {
  name: "contact",
  data() {
    return {
      index: 0,
      name: "",
      phone: "",
      email: "",
      message: "",
      company: "",
      checkedcontact: [],
      errors: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.initFooterHeight();
    },
    sendEmail(e) {
      this.errors = [];
      if (!this.name) this.errors.push("Name required.");
      if (!this.email) this.errors.push("Email required.");
      if (!this.message) this.errors.push("Message required.");
      if (this.name && this.email) {
        try {
          /*
						  for (this.index = 0; this.index < this.checkedcontact.length; this.index++) {
							 	if(this.checkedcontact[this.index] == 'operations'){  
							   			console.log(this.checkedcontact[this.index]);
										emailjs.sendForm('service_888e61q', 'template_4ig2n5j', e.target,'user_pOxKObRIUjM12T65F08qW')
								 }
								 if(this.checkedcontact[this.index] == 'customers'){
									 console.log(this.checkedcontact[this.index])
									emailjs.sendForm('service_888e61q', 'template_kenedkj', e.target,'user_pOxKObRIUjM12T65F08qW')
								 }
								 if(this.checkedcontact[this.index] == 'members'){
									 console.log(this.checkedcontact[this.index])
									 emailjs.sendForm('service_888e61q', 'template_qzvvck4', e.target,'user_pOxKObRIUjM12T65F08qW')
								 }
							}
							*/
          emailjs.sendForm(
            "service_888e61q",
            "template_fs71hz9",
            e.target,
            "user_pOxKObRIUjM12T65F08qW"
          );
        } catch (error) {
          console.log({ error });
        }
        // Reset form field
        this.name = "";
        this.email = "";
        this.phone = "";
        this.message = "";
        this.company = "";
        this.checkedcontact = [];
      }
    },
    initFooterHeight() {
      var footerHeight = $("footer").outerHeight();
      $(".main-content").css("margin-bottom", footerHeight);
    },
  },
};
</script>
<style scoped>
.map-container {
  overflow: hidden;
  padding-bottom: 56.25%;
  position: relative;
  height: 0;
}
.map-container iframe {
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  position: absolute;
}
</style>
